SC.profile = (function () {
  var api = {};

  var init = function () {
    // Set a current page variable globally
    // This lets infinite scrolling on the history tab to work so we can set it back to 0 when you switch tabs with AJAX
    window.soulcycle.profile = {
      page: 0
    };

    setupEvents();
  };

  /**
   * Function that sets up the event handlers for the page. The handlers are:
   * 1. Switching the tab content when a user clicks on a profile tab. For example from reserved classes to bookmarks.
   * 2. Logging a share event in mParticle for any click on a share icon. (Facebook, Twitter, Email).
   * 3. Handler to create a share modal for a Facebook share. Uses the FB.ui() event to fill the share dialog box.
   * @returns {void}
   */
  function setupEvents() {
    var genericErrorMessage = 'Uh oh. Something\'s not right. Please try that action again.';
    var $contentContainer = $('.profile-content-container');
    var $document = $(document);

    // Event handler to update the content of the tab with an AJAX call
    // It fires on click or keyup on an 'Enter' button press
    $('.profile-tabs__tab').on('click keyup', function (e) {
      var $target = $(e.target);

      if ($target.hasClass('profile-tabs__tab--active')) {
        return;
      }

      if (e.key !== 'Enter' && e.type === 'keyup') {
        return;
      }

      var tab = $target.data('tab');
      var url = '/profile/' + tab + '/';

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'html',
        tab: tab,
        success: function (data) {
          updatePageUrl(url);
          toggleActiveTab($target);
          resetCurrentPage();
          $('#data-container').html(data);
          loadPageScript(tab);
          if (tab === 'my_soul/about_me') {
            // eslint-disable-next-line no-undef
            creditCardFields();
          }

          // When we switch tabs we should trigger a scroll event on the window.
          // This will trigger the infinite scroll if loading message is already on the screen.
          var scrollEvent = new Event('scroll');
          window.dispatchEvent(scrollEvent);
        },
        error: function () {
          confirmation(null, 'Oops! An error occurred while submitting your request. Try that again!');
        }
      });
    });

    // mParticle Log Event Functions - Upcoming - Reserved Classes
    $contentContainer.on('click', '#profile-upcoming .profile-share-link', function () {
      /**
       * mParticle Event Tracking - Social Share - Profile Page
       */
      var $button = $(this);
      var shareInfo = $(this).closest('.profile-social-container').data();
      var eventData = {
        'Platform': $button.data('platform'),
        'Instructor Nickname': shareInfo.instructorNickname,
        'Instructor ID': shareInfo.instructorId,
        'Location': shareInfo.location,
        'Class Type': shareInfo.classType,
        'Class Time': shareInfo.classTime,
        'Class ID': shareInfo.classId,
        'Studio Name': shareInfo.studioName,
        'Share Type': shareInfo.shareType,
        'Bike Booked': shareInfo.bikeBooked
      };

      SC.analytics.mp.sendEvent('Share', 'social', eventData, shareInfo.shareType + ' ' + shareInfo.location);
    });

    // Social Share for Facebook Clicks on My Account
    $contentContainer.on('click', '.profile-share-link--fb', function (e) {
      e.preventDefault();

      var $target = $(e.target);
      var quote = $target.data('quote');
      var shareUrl = $target.data('url');

      FB.ui({
        method: 'share',
        display: 'popup',
        href: shareUrl,
        mobile_iframe: true,
        quote: quote
      });
    });

    /**
     * Unreserve a class from the Reserved Classes tab of Upcoming Classes in Profile.
     */
    $contentContainer.on('click', '.profile-button--unreserve', function (e) {
      e.preventDefault();

      var $unreserveButton = $(this);
      var classData = $unreserveButton.data();
      var $reservation = $unreserveButton.closest('.profile-class-container');
      var reservationId = $reservation.data('reservation-id');

      /**
       * mParticle logEvent - Taps to Unreserve
       */
      var eventData = {
        'Location': 'My Account',
        'Booking Channel': 'Reserved Classes',
        'Instructor Nickname': classData.instructorNickname,
        'Instructor ID': classData.instructorId,
        'Class Type': classData.classType,
        'Class ID': classData.classId,
        'Studio Name': classData.studioName,
        'Class Time': classData.classTime,
        'Bikes Available Percentage': '',
        'Total Bikes Booked': '',
        'Bike Number': classData.seatId
      };

      SC.analytics.mp.logEvent('Taps to Unreserve', 'navigation', eventData);

      if ($unreserveButton.hasClass('after-5pm')) {
        /**
         * mParticle sendEvent - Taps Unreserve Response - After 5pm
         * Sends an mParticle event with a label for GA event.
         *
         * GA Event Info:
         * Category: Navigation
         * Action: Taps Unreserve Response
         * Label: After 5pm
         */
        eventData['Response Type'] = 'After 5pm';
        SC.analytics.mp.sendEvent('Taps Unreserve Response', 'navigation', eventData, 'After 5pm');

        if ($unreserveButton.hasClass('missed-soul-active')) {
          if ($unreserveButton.data('seat-id')) {
            missedReservation($reservation);
          } else {
            confirmation(false, "Oops! There are no cancellations after 5 PM. If you're on the waitlist, your credit will be returned to your account after the class is over.", false, 3);
          }
        } else {
          confirmation(false, 'Oops! There are no cancellations after 5 PM.', false, 3);
        }

        return false;
      }

      // If the reservation was booked with Soul Early,
      // Display an additional message about Soul Early fee being non-refundable.
      var soulEarlyMessage = $reservation.data('soul-early') ?
        ' The $15 Soul Early fee is non-refundable.' :
        '';

      if (!window.confirm('Are you sure you want to unreserve this class?' + soulEarlyMessage)) {
        /**
         * mParticle sendEvent - Taps to Unreserve Confirmation - Success = No
         * Sends an mParticle event with a label for GA event.
         *
         * GA Event Info:
         * Category: Navigation
         * Action: Taps to Unreserve Confirmation
         * Label: No
         */
        eventData.Success = 'No';
        SC.analytics.mp.sendEvent('Taps to Unreserve Confirmation', 'navigation', eventData, eventData.Success);

        return false;
      }

      /**
       * mParticle sendEvent - Taps to Unreserve Confirmation - Success = Yes
       * Sends an mParticle event with a label for GA event.
       *
       * GA Event Info:
       * Category: Navigation
       * Action: Taps to Unreserve Confirmation
       * Label: Yes
       */
      eventData.Success = 'Yes';
      SC.analytics.mp.sendEvent('Taps to Unreserve Confirmation', 'navigation', eventData, eventData.Success);


      /**
       * AJAX request to unreserve the class.
       */
      $.ajax({
        method: 'POST',
        dataType: 'json',
        url: '/profile/unreserve-class/',
        data: {
          'reservation_id': reservationId,
          'csrf_token': window.soulcycle.noncePool.pop()
        },
        success: function (data) {
          if (!data.success) {
            var label;

            switch (data.code) {
            case 'noreservation':
            case 'noclass':
              confirmation(false, 'Invalid Form.');

              eventData['Response Type'] = 'Connection Issue';
              label = 'Connection Issue';

              break;
            case 'partnerreservation':
              confirmation(false, data.message);
              break;
            case 'after5pm':
              if ($unreserveButton.hasClass('missed-soul-active')) {
                // If the class is in the late cancellation window, provide late cancel experience.
                if ($unreserveButton.data('seat-id')) {
                  missedReservation($reservation);
                } else {
                  confirmation(false, "Oops! There are no cancellations after 5 PM. If you're on the waitlist, your credit will be returned to your account after the class is over.", false, 3);
                }
              } else {
                confirmation(false, 'Oops! There are no cancellations after 5 PM.', false, 3);

                eventData['Response Type'] = 'After 5pm';
                label = 'After 5pm';
              }

              break;
            default:
              confirmation(false, 'Oops! An error occurred while submitting your request. Try that again!');

              eventData['Response Type'] = 'Connection Issue';
              label = 'Connection Issue';

              break;
            }

            /**
             * mParticle sendEvent - Taps Unreserve Response - Connection Issue
             * Sends an mParticle event with a label for GA event.
             *
             * GA Event Info:
             * Category: Navigation
             * Action: Taps Unreserve Response
             * Label: Connection Issue
             */
            SC.analytics.mp.sendEvent('Taps Unreserve Response', 'navigation', eventData, label);

            return;
          }
          confirmation(false, "We'll miss you, but thanks for unreserving your class");

          /**
           * mParticle sendEvent - Taps Unreserve Response - Success
           * Sends an mParticle event with a label for GA event.
           *
           * GA Event Info:
           * Category: Navigation
           * Action: Taps Unreserve Response
           * Label: Success
           */
          eventData['Response Type'] = 'Success';
          SC.analytics.mp.sendEvent('Taps Unreserve Response', 'navigation', eventData, 'Success');

          /**
           * Dynamically increment the riders credit display
           */
          SC.utils.ui.incrementOrDecrementSeriesMenu(data, 'increment');

          /**
           * Old GA sendEvent - Canceling Reservation
           * Deprecated: Will be removed soon.
           */
          SC.analytics.ga.sendEvent('booking', 'unreserve', reservationId.toString());

          // Remove reservation from list.
          removeClass($reservation);
        },
        error: function () {
          confirmation(false, genericErrorMessage);

          /**
           * mParticle sendEvent - Taps Unreserve Response - 500 Error
           * Sends an mParticle event with a label for GA event.
           *
           * GA Event Info:
           * Category: Navigation
           * Action: Taps Unreserve Response
           * Label: 500 Error
           */
          var label = '500 Error';
          eventData['Response Type'] = label;
          SC.analytics.mp.sendEvent('Taps Unreserve Response', 'navigation', eventData, label);
        }
      });

      return true;
    });

    /**
     * Reserve a class from Bookmarks tab of Upcoming Classes in Profile.
     * Redirects to bike map for cycle classes
     */
    $contentContainer.on('click', '.profile-button--reserve', function (e) {
      e.stopPropagation();

      var $target = $(e.target);
      var classData = $target.data();

      /**
       * mparticle sendEvent - Click Reserve Button
       * Sends an mparticle event and a label for GA event.
       *
       * GA Event Info:
       * Category = Navigation
       * Action: Click Reserve Button
       * Label: Bookmarks
       */
      var eventData = {
        'Class Time': classData.classTime,
        'Class Type': classData.classType,
        'Instructor Nickname': classData.instructor,
        'Instructor ID': classData.instructorId,
        'Class ID': classData.classId,
        'Studio Name': classData.studio,
        'Location': classData.location
      };

      SC.analytics.mp.sendEvent('Click Reserve Button', 'navigation', eventData, classData.location);
    });

    /**
     * Waitlist a class in Bookmarks tab of Upcoming Classes in Profile.
     */
    $contentContainer.on('click', '.profile-button--waitlist', function (e) {
      var $target = $(e.target);

      e.preventDefault();
      e.stopPropagation();

      var soulcycle = window.soulcycle;

      // Make sure the user is still logged in or else display an error message
      if (!soulcycle.rider.id) {
        confirmation(undefined, 'You must be logged in to join a class waitlist.');
        return;
      }

      toggleThrobber(true);
      var classId = $target.data('class-id');

      /**
       * Send AJAX call to waitlist a user for the specified class
       */
      $.ajax({
        url: '/find-a-class/join-waitlist/',
        method: 'POST',
        dataType: 'json',
        data: {
          'class_id': classId,
          'csrf_token': window.soulcycle.noncePool.pop()
        },
        success: function (data) {
          if (data.success) {
            var classData = $target.data();
            var eventData = {
              'Class ID': classData.analyticsLabel,
              'Location': classData.location,
              'Instructor Nickname': classData.instructor,
              'Instructor ID': classData.instructorId,
              'Studio Name': classData.studio,
              'Class Type': classData.classType,
              'Class Time': classData.classTime
            };
            var $bookmark = $target.closest('.profile-class-container');

            confirmation(undefined, "You've successfully joined the waitlist for this class!");

            /**
             * Old GA sendEvent - waitlist button
             * Deprecated: Will be removed soon.
             *
             * category = page
             * action = waitlisted
             * label = class id
             */
            SC.analytics.ga.sendEvent(classData.analyticsCategory, classData.analyticsAction, classData.analyticsLabel.toString());

            /**
             * mparticle analytics event tracking - waitlist button
             * eventName = Add to Waitlist
             * eventCategory = Navigation
             */
            SC.analytics.mp.sendEvent('Taps Add to Waitlist', 'navigation', eventData, classData.location);

            // Decrement the user's series count after waitlisting a class.
            SC.utils.ui.incrementOrDecrementSeriesMenu(data, 'decrement');

            // Remove the bookmark after a successful unbooking event.
            removeClass($bookmark);

            return;
          }

          var message = data.message || genericErrorMessage;
          var linkRouteName;

          // Set the link in the confirmation dropdown to series_purchase page if rider doesn't have credits
          if (data.code === 'insufficientseries') {
            linkRouteName = 'series_purchase';
          }

          confirmation(linkRouteName, message);
        },
        error: function () {
          confirmation(undefined, genericErrorMessage);
        },
        complete: function () {
          toggleThrobber(false);
        }
      });
    });

    /**
     * Unbookmark a Class from Bookmarks tab of Upcoming Classes in Profile.
     */
    $contentContainer.on('click keyup', '.remove-bookmark', function (e) {
      // If the keyup event was not the enter key or spacebar, don't remove the bookmark
      if (e.key !== 'Enter' && e.key !== ' ' && e.type === 'keyup') {
        return;
      }

      var $button = $(this);
      var $bookmark = $button.closest('.profile-class-container');
      var classData = $button.data();
      var targetState = 0;
      var $form = $button.closest('form');

      $form.ajaxSubmit({
        dataType: 'json',
        data: {
          class_id: classData.analyticsLabel,
          target_state: targetState,
          csrf_token: window.soulcycle.noncePool.pop()
        },
        success: function (data) {
          $form.updateCsrfToken();

          if (!data.success) {
            confirmation(undefined, genericErrorMessage);
            return;
          }

          /**
           * mparticle analytics event tracking - taps to bookmark/unbookmark
           */
          var eventData = {
            'Location': classData.label,
            'Instructor Nickname': classData.instructorNickname,
            'Instructor ID': classData.instructorId,
            'Studio Name': classData.studioName,
            'Class Type': classData.classType,
            'Class Time': classData.classTime,
            'Class ID': classData.analyticsLabel
          };

          SC.analytics.mp.sendEvent('Taps to Unbookmark Class', 'navigation', eventData, classData.label);

          /**
           * Remove the bookmark after a successful unbooking event.
           */
          removeClass($bookmark);
        },
        error: function () {
          $form.updateCsrfToken();
          confirmation(undefined, genericErrorMessage);
        }
      });
    });

    // Profile Purchase History tab - Available Series Menu - Toggle Series Transfer Switch
    $document.on('click keyup', '.profile-series-menu-transfer__switch', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // If the keyup event was not the enter key or spacebar, don't toggle series transfer.
      if (e.key !== 'Enter' && e.key !== ' ' && e.type === 'keyup') {
        return;
      }

      // Send an AJAX request to toggle series transfer for the rider.
      $.ajax({
        method: 'post',
        url: '/profile/toggle-series-transfer/',
        data: $(this).closest('form').serialize()
      }).done(function (response) {
        SC.utils.ui.updateSeriesTransferMessage(response);
        confirmation(undefined, response.payload.message);
      }).fail(function (error) {
        console.log(error);
      });
    });

    /**
     * Old GA sendEvent - Click Book a Class - On the Reserved Classes tab of Upcoming Classes in Profile.
     * Deprecated: Will be removed soon.
     */
    $contentContainer.on('click', '.profile-no-classes__button', function () {
      SC.analytics.ga.sendEvent('profile', 'Click Book a Class', 'reserved classes', $(this).attr('data-reserved-classes'));
    });
  }

  // Mark a class a missed
  function missedReservation($reservation, confirmed) {
    var $unreserveButton = $reservation.find('.profile-button--unreserve');
    var classInfo = $unreserveButton.data();
    var reservationInfo = $reservation.data();

    if (!confirmed) {
      // Set the parameters for the confirm_dialog modal.
      var parameters = {
        buttons: {
          accept: {
            text: 'Cancel My Reservation',
            callback: function () {
              missedReservation($reservation, true);
            }
          },
          decline: {
            text: "Nevermind, I'm coming!"
          }
        },
        textContainers: {
          header: {
            text: "It's after 5:00pm..."
          },
          main: {
            text: 'If you cancel now, this class will remain deducted from your account. ' + genClassInfoBlock(classInfo)
          },
          disclaimer: {
            text: 'Please note, this cancellation request is after our 5pm deadline. If you confirm, this class will be marked as a "missed soul". You can review our cancellation policy <a href="https://www.soul-cycle.com/legal/terms-and-conditions/" target="_blank">HERE</a>.'
          }
        }
      };

      // If this reservation was made with SoulEarly,
      // Generate the Soul Early non-refundable notice and banner.
      if (reservationInfo.soulEarly) {
        parameters.textContainers.disclaimer.text += genSoulEarlyNotice();
        parameters.textContainers.banner = {
          text: '<p class="confirm-dialog__banner__soul-early">BOOKED WITH SOUL EARLY</p>'
        };
      }

      SC.confirmDialog.confirm(parameters);
    } else {
      var eventData = {
        'Location': 'Reserved'
      };
      var response;

      $.ajax({
        method: 'POST',
        dataType: 'json',
        url: '/profile/missed-class/',
        data: {
          'reservation_id': reservationInfo.reservationId,
          'csrf_token': window.soulcycle.noncePool.pop()
        },
        success: function (data) {
          if (!data.success) {
            switch (data.code) {
            case 'invalid':
            case 'invalid_csrf':
            case 'noreservation':
              confirmation(false, 'Invalid Form.');
              response = 'Invalid Form';
              eventData.Response = response;
              break;
            case 'class_started':
              confirmation(false, "Oops! You can't cancel a class after it has started.");
              response = 'Class Started';
              eventData.Response = response;
              break;
            case 'group_booking':
              confirmation(false, 'Your reservation was not cancelled.  Please cancel your ' +
                  'reservation through the Gympass app or website.');
              response = 'Booked in Group';
              eventData.Response = response;
              break;
            case 'bilt':
              confirmation(false, 'Bilt Rent Day Ride bikes cannot be canceled. To ensure every bike is filled, no-shows will result in a $30 charge.');
              response = 'Booked in Group';
              eventData.Response = response;
              break;
            default:
              confirmation(false, 'Oops! An error occurred while submitting your request. Try that again!');
              response = 'Unknown Error';
              eventData.Response = response;
              break;
            }

            /**
             * mParticle sendEvent - Late Cancellation - Error Response
             * Sends an mParticle event with a label for GA event.
             *
             * GA Event info:
             * Category: Navigation
             * Action: Late Cancellation
             * Response: Error Type
             */
            SC.analytics.mp.sendEvent('Late Cancellation', 'navigation', eventData, response);
            return;
          }

          confirmation(false, "We'll miss you, but thanks for unreserving your class");

          /**
           * mParticle sendEvent - Late Cancellation - Success
           * Sends an mParticle event with a label for GA event.
           *
           * GA Event info:
           * Category: Navigation
           * Action: Late Cancellation
           * Response: Success
           */
          response = 'Success';
          eventData.Response = response;
          SC.analytics.mp.sendEvent('Late Cancellation', 'navigation', eventData, response);

          // Remove reservation from list
          removeClass($reservation);
        },
        error: function () {
          confirmation(false, genericErrorMessage);
        }
      });
    }
  }

  // Generate class info template for confirmation window
  function genClassInfoBlock(classInfo) {
    return '<div class="class-info">' +
      '<div class="class-time">' + classInfo.displayDate + ' at ' + classInfo.displayTime + '</div>' +
      '<div class="class-type">' + classInfo.classType + ' with ' + classInfo.instructorNickname + '</div>' +
      '<div class="class-location">' + classInfo.studioName + '</div>' +
      '</div>';
  }

  // Generate Soul Early cancellation message
  // todo @soulaccess_todo Make price dynamic if other fees are added.
  function genSoulEarlyNotice() {
    return '<div class="soul-early-notice-container">' +
      '<div class="soul-early-notice__header">Soul Early</div>' +
      '<p class="soul-early-notice__body">The $15 Soul Early fee is non-refundable.</p>' +
      '</div>';
  }

  // Gracefully remove reservation from list
  function removeClass($reservation) {
    var $classGroup = $reservation.closest('.profile-day');

    if ($classGroup.find('.profile-class-container').length > 1) {
      $reservation.fadeOut('fast', function () {
        $reservation.remove();
      });
    } else {
      $classGroup.fadeOut('fast', function () {
        $classGroup.remove();

        // If there are no more classes (reserved/bookmarked), display an empty state.
        if ($('.profile-class-container').length === 0) {
          $('.profile-no-classes').addClass('profile-no-classes--active');
        }
      });
    }
  }

  /**
   * Updates the URL in the browser while preventing a page reload
   *
   * @param {string} urlPath url
   * @returns {void}
   */
  function updatePageUrl(urlPath) {
    window.history.pushState('', '', urlPath);
  }

  /**
   * Toggles which profile tab has the active state
   *
   * @param {string} activeTabElem active table element
   * @returns {void}
   */
  function toggleActiveTab(activeTabElem) {
    $('.profile-tabs__tab').removeClass('profile-tabs__tab--active').attr('aria-selected', function (i, attr) {
      return attr === 'true' ? 'false' : 'true';
    });
    $(activeTabElem).addClass('profile-tabs__tab--active');
  }

  /**
   * Resets the "page" to 0.
   * This is the page of class/purchase history that should be returned if the rider scrolls down on the history tab.
   * Keeps the infinite scroll consistent when switching subtabs on the history tab.
   * @returns {void}
   */
  function resetCurrentPage() {
    window.soulcycle.profile.page = 0;
  }

  /**
   * loadPageScript initializes a script for a page that was loaded via ajax.
   *
   * @param {string} tab the tab loaded in
   * @returns {void}
   */
  function loadPageScript(tab) {
    switch (tab) {
    case 'my_soul/preferences':
      SC.preferences.init();
      break;
    case 'my_soul/about_me':
      SC.aboutMe.init();
      break;
    case 'upcoming/bookmarks':
      init();
      break;
    case 'history/purchases':
      SC.series_purchases.init();
      break;
    // No Default
    }
  }

  init();
  return api;
})();
